import React, { FC } from 'react';
import { FitoListReactQuery, ConfirmationModal } from '~/Components';
import { useLanguage } from '~/Hooks';
import { IVODVideo } from '~/Models/DTO/VideoOnDemand.models';
import { useRequestVODVideos } from '~/requests/videoOnDemandService/useRequestVODVideos';
import { useVoDVideosList } from './useVoDVideosList';
import { useVODModals } from '../useVODModals';
import YogaImg from '~/Assets/Images/SportsIllustrations/Yoga2.svg';

const VoDVideosList: FC = () => {
  const { t } = useLanguage();
  const { keyOfId, settings, setItemValues, tableDefinition, defaultQuery } = useVoDVideosList();
  const { confirmationModalProps, actions } = useVODModals();

  return (
    <>
      <FitoListReactQuery<IVODVideo>
        keyOfId={keyOfId}
        settings={settings}
        title={t('void.videos.title')}
        setItemValues={setItemValues}
        tableDefinition={tableDefinition}
        defaultQuery={defaultQuery}
        queryResults={useRequestVODVideos}
        pageSize={50}
        searchTextPlaceholder={t('app.search.videos')}
        actions={actions}
        placeholder={{
          imgSrc: YogaImg,
          imgAlt: t('app.vod.emptyState'),
          title: t('app.vod.emptyState'),
        }}
      />
      <ConfirmationModal {...confirmationModalProps} />
    </>
  );
};

export default VoDVideosList;
